module.exports = __webpack_public_path__ + "static/media/polygon-thick-border.b4e4e9ec.svg";